const privilegeList={
    MANAGER: 1,
    EXECUTIVE: 2,
    SPEAKER: 3,
    ATTENDEE: 4,
    SUPPORT: 5,
    SECRETARY: 6,
    CHAIRMAN: 7
}
export default  privilegeList